import useSWR from "swr";


export const useFetchTotalStaff = (restaurantId?: string) => {
  const fetchKey = restaurantId ? `restaurant_staff/restaurants/${restaurantId}/staff/total/` : null;
  const { data: totalStaff, error, isLoading } = useSWR<number>(fetchKey)
  return { totalStaff, isLoading, error };
};